import * as Yup from 'yup';

import { Button, Form, Spinner } from 'react-bootstrap';
import { Field, Formik } from 'formik';
import { contentfulPropTypes, netZeroPropTypes } from '../../propTypes';

import { LoginCard } from '../../ui';
import { RadioWrapper } from '../../ui/Styled';
import React from 'react';
import cx from 'classnames';
import { useNavigate } from 'react-router';
import withContentfulTag from '../../utils/withContentfulTag';

const schema = Yup.object().shape({
  heatingRadio: Yup.mixed()
    .oneOf([
      'mains-gas',
      'oil',
      'petroleum',
      'heat-pump',
      'electric-radiators',
      'other',
    ])
    .required(),
});

const HeatingContainer = ({
  contentful,
  loading,
  fetched,
  heatingMethod,
  setHeatingMethod,
}) => {
  const navigate = useNavigate();

  const onSubmitHeatingMethod = ({ heatingRadio }) => {
    setHeatingMethod(heatingRadio);
    navigate('/net-zero/energy');
  };

  return (
    !loading &&
    fetched && (
      <LoginCard onBack={() => navigate('/net-zero')}>
        <p>
          Step <strong>1</strong> of <strong>4</strong>
        </p>
        <h1 className="pb-3">{contentful.title}</h1>
        <p>{contentful.subtitle}</p>
        <Formik
          onSubmit={onSubmitHeatingMethod}
          initialValues={{
            heatingRadio: heatingMethod,
          }}
          validationSchema={schema}>
          {({ handleSubmit, isSubmitting, values }) => (
            <Form onSubmit={handleSubmit}>
              <Field name="heatingRadio">
                {({ field, meta }) => (
                  <RadioWrapper
                    className={cx({ selected: field.value === 'mains-gas' })}>
                    <Form.Check
                      type="radio"
                      name={field.name}
                      id="mains-gas"
                      value="mains-gas"
                      label="Mains gas"
                      onChange={field.onChange}
                      onBlur={field.onBlur}
                      className={cx({ error: !!meta.error })}
                    />
                  </RadioWrapper>
                )}
              </Field>
              <Field name="heatingRadio">
                {({ field, meta }) => (
                  <RadioWrapper
                    className={cx({ selected: field.value === 'oil' })}>
                    <Form.Check
                      type="radio"
                      name={field.name}
                      id="oil"
                      value="oil"
                      label="Oil"
                      onChange={field.onChange}
                      onBlur={field.onBlur}
                      className={cx({ error: !!meta.error })}
                    />
                  </RadioWrapper>
                )}
              </Field>
              <Field name="heatingRadio">
                {({ field, meta }) => (
                  <RadioWrapper
                    className={cx({ selected: field.value === 'petroleum' })}>
                    <Form.Check
                      type="radio"
                      name={field.name}
                      id="petroleum"
                      value="petroleum"
                      label="Liquefied petroleum gas (LPG)"
                      onChange={field.onChange}
                      onBlur={field.onBlur}
                      className={cx({ error: !!meta.error })}
                    />
                  </RadioWrapper>
                )}
              </Field>
              <Field name="heatingRadio">
                {({ field, meta }) => (
                  <RadioWrapper
                    className={cx({ selected: field.value === 'heat-pump' })}>
                    <Form.Check
                      type="radio"
                      name={field.name}
                      id="heat-pump"
                      value="heat-pump"
                      label="Electric heat pump"
                      onChange={field.onChange}
                      onBlur={field.onBlur}
                      className={cx({ error: !!meta.error })}
                    />
                  </RadioWrapper>
                )}
              </Field>
              <Field name="heatingRadio">
                {({ field, meta }) => (
                  <RadioWrapper
                    className={cx({
                      selected: field.value === 'electric-radiators',
                    })}>
                    <Form.Check
                      type="radio"
                      name={field.name}
                      id="electric-radiators"
                      value="electric-radiators"
                      label="Electric storage radiators"
                      onChange={field.onChange}
                      onBlur={field.onBlur}
                      className={cx({ error: !!meta.error })}
                    />
                  </RadioWrapper>
                )}
              </Field>
              <Button
                className="w-100"
                type="submit"
                variant="primary"
                disabled={!values.heatingRadio}>
                {!isSubmitting ? (
                  contentful.primaryButtonText
                ) : (
                  <Spinner animation="border" size="sm" />
                )}
              </Button>
            </Form>
          )}
        </Formik>
      </LoginCard>
    )
  );
};

HeatingContainer.propTypes = {
  ...contentfulPropTypes,
  ...netZeroPropTypes,
};

export default withContentfulTag(
  HeatingContainer,
  'web_app_netzero_heating_page',
);
